import CodecParser from "./src/CodecParser.js";

export default CodecParser;
